import { RegionState } from './region.store';

export const isUSRegionSelector = (state: RegionState) => state?.region?.country === 'US';
export const isAURegionSelector = (state: RegionState) => state?.region?.country === 'AU';
export const getRegionSelector = (state: RegionState) => state?.region;
